export default "__VITE_ASSET__35760182__"